// NOTICE: KAPTION-INTEGRATION - Quantity-first WhatsApp outbound delivery policy.
export const KAPTION_DELIVERY_MODES = Object.freeze({
  IMMEDIATE: 'immediate',
  UNDO: 'undo',
  PAIR: 'combine_2',
  TRIO: 'combine_3',
  BUNDLE: 'combine_5',
});

export const KAPTION_DELIVERY_MODE_CONFIG = Object.freeze({
  [KAPTION_DELIVERY_MODES.IMMEDIATE]: { targetCount: 1, aggregate: false },
  [KAPTION_DELIVERY_MODES.UNDO]: { targetCount: 1, aggregate: false },
  [KAPTION_DELIVERY_MODES.PAIR]: { targetCount: 2, aggregate: true },
  [KAPTION_DELIVERY_MODES.TRIO]: { targetCount: 3, aggregate: true },
  [KAPTION_DELIVERY_MODES.BUNDLE]: { targetCount: 5, aggregate: true },
});

export const resolveKaptionDeliveryMode = (
  uiSettings = {},
  { batchingEnabled = false } = {}
) => {
  const mode = uiSettings.kaption_delivery_mode;
  if (KAPTION_DELIVERY_MODE_CONFIG[mode]) return mode;
  if (uiSettings.kaption_undo_send_enabled) return KAPTION_DELIVERY_MODES.UNDO;
  return batchingEnabled
    ? KAPTION_DELIVERY_MODES.TRIO
    : KAPTION_DELIVERY_MODES.IMMEDIATE;
};

export const getKaptionDeliveryModeConfig = mode =>
  KAPTION_DELIVERY_MODE_CONFIG[mode] ||
  KAPTION_DELIVERY_MODE_CONFIG[KAPTION_DELIVERY_MODES.IMMEDIATE];

export const isKaptionAggregationEligible = payload => {
  const content = payload?.content ?? payload?.message;
  const files = payload?.files ?? payload?.attachments;
  const attributes =
    payload?.content_attributes ?? payload?.contentAttributes ?? {};
  const templateParams = payload?.template_params ?? payload?.templateParams;
  return Boolean(
    payload &&
      !payload.private &&
      !payload.file &&
      !files?.length &&
      !templateParams &&
      !attributes.in_reply_to &&
      !attributes.kaption_translations &&
      typeof content === 'string' &&
      content.trim()
  );
};
